export enum ErrorMessages {
  Required = 'This is required',
  BadEmail = 'Please enter a valid email address',
  BadPhoneNo = 'Please enter a valid UK phone number',
}

export const EMAIL_REGEX = /^[A-Za-z0-9_!#$%&'*+/=?`{|}~^.-]+@[A-Za-z0-9.-]+$/g;
export const PHONE_REGEX = /^(?:0|\+?44)(?:\d\s?){9,10}$/g;
